import { Modal, Typography } from "antd";
import AppButton from "components/libs/button";
import React, { useRef, useState } from "react";
import Email from "../../assets/images/app/mail_verif.svg";

const { Text } = Typography;

interface OtpModalProps {
    visible: boolean;
    email: string,
    onCancel: () => void;
    onSubmitOtp: (otp: string) => void;
    isLoading: boolean;
}

const EmailOTPModal: React.FC<OtpModalProps> = ({ visible, email, onCancel, onSubmitOtp, isLoading }) => {

    const [otp, setOtp] = useState<string[]>(Array(4).fill(''));
    const inputsRef = useRef<(HTMLInputElement | null)[]>([]);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1050);
    const handleResize = () => {
        setIsMobile(window.innerWidth <= 1050);
    };
    window.addEventListener('resize', handleResize);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const newOtp = [...otp];
        newOtp[index] = e.target.value;
        setOtp(newOtp);

        // Move to the next input field if needed
        if (e.target.value && index < 3) {
            const nextInput = document.getElementById(`email-otp-input-${index + 1}`);
            nextInput?.focus();
        }
    };

    const handlePasteOrInput = (e: React.FormEvent<HTMLInputElement> | React.ClipboardEvent<HTMLInputElement>) => {
        let pastedData = "";

        if ("clipboardData" in e) {
            // Desktop paste
            e.preventDefault();
            pastedData = e.clipboardData.getData("text").trim();
        } else {
            // Mobile input (Safari/iOS often fires this instead of paste)
            pastedData = (e.currentTarget as HTMLInputElement).value.trim();
        }

        if (!/^\d+$/.test(pastedData)) return;

        const pastedArray = pastedData.split("").slice(0, otp.length);
        const newOtp = [...otp];

        pastedArray.forEach((num, index) => {
            newOtp[index] = num;
        });

        setOtp(newOtp);
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputsRef.current[index - 1]?.focus(); // move back
        }
    };

    const handleSubmit = () => {

        const otpValue = otp.join('');

        if (otpValue.length !== 4) {
            alert("Entre le code OTP reçu par email !");
            return;
        }

        // Call API or handle OTP verification
        onSubmitOtp(otpValue);
    };

    return (
        <Modal
            title={null}
            visible={visible}
            onCancel={onCancel}
            footer={null}
            centered
        >
            <div style={{ textAlign: "center" }}>
                <img src={Email} height={70} style={{ marginBottom: "10px" }}></img>
                <Text strong style={{ display: "block", marginBottom: 8 }}>
                    Vérification de l'adresse email
                </Text>
                <Text>
                    Nous avons envoyé un code sur <b>{email}</b>
                </Text>
                <div onClick={onCancel} style={{ fontSize: "1.05em", fontWeight: "500", textDecoration: "underline", color: "#80b1b2", cursor: "pointer" }}>Corriger le mail</div>

                {/* OTP input (AntD v5) */}
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", margin: "40px auto" }}>
                    {otp.map((value, index) => (
                        <input
                            key={index}
                            id={`email-otp-input-${index}`}
                            ref={(el) => (inputsRef.current[index] = el)}
                            type="text"
                            inputMode="numeric"
                            value={value}
                            onChange={(e) => handleChange(e, index)}
                            maxLength={otp.length}
                            onPaste={handlePasteOrInput}
                            onInput={handlePasteOrInput}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            style={{ height: isMobile ? "30px" : "50px", width: isMobile ? "30px" : "50px", textAlign: 'center', marginRight: '5px', marginLeft: "5px", border: "1px solid #ccc", borderRadius: isMobile ? "5px" : "8px" }}
                        />
                    ))}
                </div>

                <div style={{ marginBottom: 15 }}>
                    <Text type="secondary">
                        Email pas reçu ? Patiente 5 minutes et vérifie tes spams. Si tu ne reçois toujours rien, <a href="/contact" target="_blank" rel="noopener noreferrer" style={{ cursor: "pointer" }}>contacte-nous</a> pour confirmer ton inscription.
                    </Text>
                </div>

                <AppButton
                    onClick={() => handleSubmit()}
                    disabled={otp.length < 4}
                    loading={isLoading}
                >
                    Vérifier et Continuer
                </AppButton>
            </div>
        </Modal>
    );
};

export default EmailOTPModal;
